const ALLOWED_TAGS = new Set([
  "a", "b", "blockquote", "br", "em", "h1", "h2", "h3", "hr", "i", "img",
  "li", "ol", "p", "s", "span", "strong", "u", "ul"
])

const REMOVED_TAGS = new Set(["iframe", "object", "script", "style", "svg"])

function safeUrl(value, allowRelative = true) {
  const url = String(value || "").trim()
  if (!url) return ""
  if (allowRelative && (url.startsWith("/") || url.startsWith("./") || url.startsWith("../"))) return url

  try {
    const parsed = new URL(url, window.location.origin)
    return ["http:", "https:"].includes(parsed.protocol) ? parsed.href : ""
  } catch (error) {
    return ""
  }
}

function sanitizeNode(node) {
  Array.from(node.children).forEach(child => {
    const tagName = child.tagName.toLowerCase()

    if (REMOVED_TAGS.has(tagName)) {
      child.remove()
      return
    }

    if (!ALLOWED_TAGS.has(tagName)) {
      sanitizeNode(child)
      while (child.firstChild) child.parentNode.insertBefore(child.firstChild, child)
      child.remove()
      return
    }

    const originalHref = tagName === "a" ? child.getAttribute("href") : ""
    const originalSource = tagName === "img" ? child.getAttribute("src") : ""
    const originalAlt = tagName === "img" ? child.getAttribute("alt") : ""
    Array.from(child.attributes).forEach(attribute => child.removeAttribute(attribute.name))

    if (tagName === "a") {
      const href = safeUrl(originalHref)
      if (href) {
        child.setAttribute("href", href)
        child.setAttribute("target", "_blank")
        child.setAttribute("rel", "noopener noreferrer")
      }
    }

    if (tagName === "img") {
      const source = safeUrl(originalSource)
      if (source) child.setAttribute("src", source)
      child.setAttribute("alt", originalAlt || "")
      child.setAttribute("loading", "lazy")
    }

    sanitizeNode(child)
  })
}

/**
 * 系统通知由后台运营录入，渲染前仅保留受控的富文本标签和安全 URL。
 */
export function sanitizeRichText(value) {
  const source = String(value || "").trim()
  if (!source) return ""

  const documentNode = new DOMParser().parseFromString(`<div>${source}</div>`, "text/html")
  const container = documentNode.body.firstElementChild
  if (!container) return ""

  sanitizeNode(container)
  return container.innerHTML
}
